import { useQuery } from "@tanstack/react-query";

import { getPostModuleFeedbackQuestionsApiCall } from "./utils.api";
import { postModuleFeedbackQuestionsKeys } from "../../../../redux/services/postModuleFeeeback";

export const useGetPostMoudleFeedbackQuestionTypeKeys = (payload) =>{
    const {languageId , module , courseId, moduleId}= payload;

    return useQuery({
        queryKey: postModuleFeedbackQuestionsKeys.getPostModuleFeedBackQuestions(),
        queryFn: () => getPostModuleFeedbackQuestionsApiCall({languageId , module ,courseId ,  moduleId }),
    });
}